module.exports = __webpack_public_path__ + "static/media/curly_brackets.0c86d754.png";